import { render, staticRenderFns } from "./shopStatusBar.vue?vue&type=template&id=d2fbe0da&scoped=true"
import script from "./shopStatusBar.vue?vue&type=script&lang=js"
export * from "./shopStatusBar.vue?vue&type=script&lang=js"
import style0 from "./shopStatusBar.vue?vue&type=style&index=0&id=d2fbe0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fbe0da",
  null
  
)

export default component.exports